(function () {
  "use strict";
  var L = window.Lagom;
  if (!(!L || !L.q)) {
    var q = L.q,
      qa = L.qa,
      motionOff = L.motionOff;
    (function () {
      var dlg = q("[data-manifesto]");
      if (!dlg || !dlg.showModal) return;
      var lift = q("[data-book-lift]", dlg),
        scroller = q("[data-manifesto-paper]", dlg),
        closeBtn = q("[data-manifesto-close]", dlg),
        shade = q("[data-book-shade]", dlg),
        shine = q("[data-book-shine]", dlg),
        opener = null,
        busy = !1,
        timers = [],
        loaded = null,
        flows = qa("[data-manifesto-flow]", dlg),
        wide = window.matchMedia("(min-width: 768px)");
      function fit() {
        var main = flows[0],
          fs = 15;
        if (
          (flows.forEach(function (f) {
            f.style.fontSize = "";
          }),
          !(!wide.matches || !main))
        )
          for (; fs > 10 && main.scrollWidth > main.clientWidth + 1;)
            ((fs -= 0.5),
              flows.forEach(function (f) {
                f.style.fontSize = fs + "px";
              }));
      }
      window.addEventListener("resize", function () {
        dlg.open && fit();
      });
      function later(fn, ms) {
        timers.push(window.setTimeout(fn, ms));
      }
      function clearTimers() {
        (timers.forEach(clearTimeout),
          (timers = []),
          [shade, shine].forEach(function (el) {
            el &&
              el.getAnimations().forEach(function (a) {
                a.cancel();
              });
          }));
      }
      function preload() {
        if (loaded) return loaded;
        var sm = window.matchMedia("(max-width: 767px)").matches;
        function src(k) {
          return (
            (sm && dlg.getAttribute("data-" + k + "-sm")) ||
            dlg.getAttribute("data-" + k)
          );
        }
        return (
          ["cover", "page", "edge"].forEach(function (k) {
            dlg.style.setProperty("--book-" + k, 'url("' + src(k) + '")');
          }),
          (loaded = new Promise(function (res) {
            var i = new Image();
            ((i.onload = i.onerror = res),
              (i.src = src("cover")),
              i.decode && i.decode().then(res, res));
          })),
          loaded
        );
      }
      function fromButton() {
        var r =
          opener && opener.getBoundingClientRect
            ? opener.getBoundingClientRect()
            : null;
        return !r || (!r.width && !r.height)
          ? "translate(0px," + Math.round(innerHeight * 0.4) + "px) scale(.6)"
          : "translate(" +
              Math.round(r.left + r.width / 2 - innerWidth / 2) +
              "px," +
              Math.round(r.top + r.height / 2 - innerHeight / 2) +
              "px) scale(.6)";
      }
      function jump(el, props) {
        ((el.style.transition = "none"),
          Object.keys(props).forEach(function (k) {
            el.style[k] = props[k];
          }),
          el.offsetWidth,
          (el.style.transition = ""));
      }
      function open(instant, from) {
        if (!(busy || dlg.open)) {
          ((busy = !0),
            clearTimers(),
            document.dispatchEvent(
              new CustomEvent("lagom:panel", { detail: "manifesto" }),
            ),
            (opener = from || document.activeElement));
          var flat = instant || motionOff();
          if (
            (dlg.classList.remove("is-closing", "is-open"),
            dlg.classList.toggle("is-flat", !!flat),
            document.documentElement.classList.add("is-manifesto-open"),
            L.lock && L.lock.lock("manifesto"),
            dlg.showModal(),
            (scroller.scrollTop = 0),
            fit(),
            dlg.classList.remove("has-turned"),
            (pg = 0),
            paginate(),
            narrow.matches && !flat && buildLeaf(),
            jump(
              lift,
              flat
                ? { transform: "", opacity: "0" }
                : { transform: fromButton(), opacity: "0" },
            ),
            closeBtn.focus({ preventScroll: !0 }),
            flat)
          ) {
            (dlg.classList.add("is-open"),
              (lift.style.opacity = ""),
              (busy = !1));
            return;
          }
          (dlg.classList.add("is-animating"),
            (lift.style.transform = ""),
            (lift.style.opacity = ""),
            later(function () {
              (dlg.classList.add("is-open"),
                shade.animate &&
                  (shade.animate(
                    [
                      { opacity: 0, transform: "translateX(0)" },
                      { opacity: 1, offset: 0.3 },
                      { opacity: 0, transform: "translateX(-40%)" },
                    ],
                    { duration: 900, easing: "ease-out" },
                  ),
                  shine.animate(
                    [
                      { opacity: 0 },
                      { opacity: 0.8, offset: 0.5 },
                      { opacity: 0.3 },
                    ],
                    { duration: 900, easing: "ease-in-out", fill: "forwards" },
                  )));
            }, 400),
            later(function () {
              (dlg.classList.remove("is-animating"), (busy = !1));
            }, 1320),
            narrow.matches && later(peek, 1700));
        }
      }
      function close() {
        if (!dlg.open || dlg.classList.contains("is-closing")) return;
        ((busy = !0),
          clearTimers(),
          (drag = null),
          stopPeek(),
          turn &&
            (leaf.classList.remove("is-on", "is-settling"),
            (turn = null),
            show(pg)));
        function done() {
          (dlg.close(),
            dlg.classList.remove(
              "is-closing",
              "is-animating",
              "is-open",
              "is-flat",
            ),
            jump(lift, { transform: "", opacity: "" }),
            (shine.style.opacity = ""),
            document.documentElement.classList.remove("is-manifesto-open"),
            L.lock && L.lock.unlock("manifesto"),
            (busy = !1),
            opener && opener.focus && opener.focus({ preventScroll: !0 }));
        }
        if (
          (dlg.classList.add("is-closing", "is-animating"),
          dlg.classList.contains("is-flat") || motionOff())
        ) {
          (dlg.classList.add("is-flat"),
            (lift.style.opacity = "0"),
            later(done, 220));
          return;
        }
        (dlg.classList.remove("is-open"),
          shine.animate &&
            shine.animate(
              [{ opacity: 0.3 }, { opacity: 0.8, offset: 0.5 }, { opacity: 0 }],
              { duration: 700, easing: "ease-in-out", fill: "forwards" },
            ),
          later(function () {
            ((lift.style.transform = fromButton()), (lift.style.opacity = "0"));
          }, 700),
          later(done, 1100));
      }
      var narrow = window.matchMedia("(max-width: 767px)"),
        paper = q(".mbook__page", dlg),
        flow = q(".manifesto__inner", scroller),
        count = q("[data-book-count]", dlg),
        prevBtn = q("[data-book-prev]", dlg),
        nextBtn = q("[data-book-next]", dlg),
        pg = 0,
        pages = 1,
        leaf = null,
        leafFlow = null,
        leafCount = null,
        leafShade = null,
        turn = null,
        drag = null;
      function setPage(el, n) {
        el.style.setProperty("--pg", n);
      }
      function label(n) {
        return n + 1 + " / " + pages;
      }
      function paginate() {
        if (!narrow.matches) {
          ((pages = 1), (pg = 0), setPage(flow, 0));
          return;
        }
        var last = flow.lastElementChild,
          w = paper.clientWidth;
        ((pages =
          last && w
            ? Math.max(
                1,
                Math.floor(
                  (last.getBoundingClientRect().right -
                    1 -
                    flow.getBoundingClientRect().left) /
                    w,
                ) + 1,
              )
            : 1),
          show(Math.min(pg, pages - 1)));
      }
      function show(n) {
        ((pg = n),
          setPage(flow, n),
          (count.textContent = label(n)),
          (prevBtn.disabled = n <= 0),
          (nextBtn.disabled = n >= pages - 1));
      }
      function buildLeaf() {
        if (!leaf) {
          ((leaf = document.createElement("div")),
            (leaf.className = "mbook__leaf"),
            leaf.setAttribute("aria-hidden", "true"),
            (leaf.inert = !0));
          var front = paper.cloneNode(!0);
          (qa("[id], [tabindex], [aria-live]", front).forEach(function (el) {
            (el.removeAttribute("id"),
              el.removeAttribute("tabindex"),
              el.removeAttribute("aria-live"));
          }),
            (leafFlow = q(".manifesto__inner", front)),
            (leafCount = q("[data-book-count]", front)),
            qa("[data-book-shade]", front).forEach(function (el) {
              el.style.opacity = "0";
            }),
            qa("[data-book-prev], [data-book-next]", front).forEach(
              function (el) {
                el.removeAttribute("aria-label");
              },
            ),
            (leafShade = document.createElement("span")),
            (leafShade.className = "mbook__leaf-shade"),
            front.appendChild(leafShade));
          var back = document.createElement("div");
          ((back.className = "mbook__leaf-back"),
            leaf.appendChild(front),
            leaf.appendChild(back),
            paper.parentNode.insertBefore(leaf, paper.nextSibling));
        }
      }
      function angle(a) {
        ((leaf.style.transform = "translateZ(0.5px) rotateY(" + a + "deg)"),
          (leafShade.style.opacity = String(Math.min(1, -a / 120))));
      }
      function begin(dir) {
        var to = pg + dir;
        if (turn || to < 0 || to >= pages) return !1;
        buildLeaf();
        var shown = dir > 0 ? pg : to;
        return (
          setPage(leafFlow, shown),
          (leafCount.textContent = label(shown)),
          leaf.classList.add("is-on"),
          leaf.classList.remove("is-settling"),
          angle(dir > 0 ? 0 : -180),
          dir > 0 && setPage(flow, to),
          (turn = { dir: dir, to: to }),
          !0
        );
      }
      function settle(done) {
        var t = turn;
        t &&
          (leaf.offsetWidth,
          leaf.classList.add("is-settling"),
          angle(t.dir > 0 ? (done ? -180 : 0) : done ? 0 : -180),
          later(function () {
            (leaf.classList.remove("is-on", "is-settling"),
              (turn = null),
              done ? (show(t.to), dlg.classList.add("has-turned")) : show(pg));
          }, 580));
      }
      function go(dir) {
        if ((stopPeek(), !(turn || pg + dir < 0 || pg + dir >= pages))) {
          if (dlg.classList.contains("is-flat") || motionOff()) {
            (show(pg + dir), dlg.classList.add("has-turned"));
            return;
          }
          begin(dir) && settle(!0);
        }
      }
      function peek() {
        if (!(
          !dlg.open ||
          turn ||
          drag ||
          pg !== 0 ||
          pages < 2 ||
          dlg.classList.contains("has-turned") ||
          !leaf ||
          !leaf.animate
        )) {
          (begin(1), (turn.peek = !0));
          var a = leaf.animate(
            [
              { transform: "translateZ(0.5px) rotateY(0deg)" },
              { transform: "translateZ(0.5px) rotateY(-32deg)", offset: 0.45 },
              { transform: "translateZ(0.5px) rotateY(0deg)" },
            ],
            { duration: 1200, easing: "ease-in-out" },
          );
          a.onfinish = a.oncancel = stopPeek;
        }
      }
      function stopPeek() {
        !turn ||
          !turn.peek ||
          (leaf.getAnimations().forEach(function (a) {
            ((a.onfinish = a.oncancel = null), a.cancel());
          }),
          leaf.classList.remove("is-on"),
          (turn = null),
          show(pg));
      }
      (paper.addEventListener("pointerdown", function (e) {
        !narrow.matches ||
          e.button > 0 ||
          e.target.closest("button") ||
          (stopPeek(),
          !turn &&
            (drag = {
              id: e.pointerId,
              x: e.clientX,
              y: e.clientY,
              t: e.timeStamp,
              on: !1,
              dir: 0,
              p: 0,
              v: 0,
            }));
      }),
        paper.addEventListener("pointermove", function (e) {
          if (!(!drag || e.pointerId !== drag.id)) {
            var dx = e.clientX - drag.x,
              dy = e.clientY - drag.y,
              w = paper.clientWidth;
            if (!drag.on) {
              if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy)) return;
              if (dlg.classList.contains("is-flat") || motionOff()) {
                ((drag = null), go(dx < 0 ? 1 : -1));
                return;
              }
              if (!begin(dx < 0 ? 1 : -1)) {
                drag = null;
                return;
              }
              ((drag.on = !0), (drag.dir = turn.dir));
              try {
                paper.setPointerCapture(e.pointerId);
              } catch (err) {}
            }
            var p = Math.max(0, Math.min(1, (drag.dir > 0 ? -dx : dx) / w));
            ((drag.v = (p - drag.p) / Math.max(1, e.timeStamp - drag.t)),
              (drag.p = p),
              (drag.t = e.timeStamp),
              angle(drag.dir > 0 ? -180 * p : -180 * (1 - p)));
          }
        }));
      function release(e) {
        if (!(!drag || e.pointerId !== drag.id)) {
          var d = drag;
          if (((drag = null), d.on)) {
            settle(e.type !== "pointercancel" && (d.p > 0.3 || d.v > 0.0015));
            return;
          }
          if (!(
            e.type !== "pointerup" ||
            Math.abs(e.clientX - d.x) > 8 ||
            Math.abs(e.clientY - d.y) > 8
          )) {
            var r = paper.getBoundingClientRect(),
              x = (e.clientX - r.left) / r.width;
            x > 0.67 ? go(1) : x < 0.33 && go(-1);
          }
        }
      }
      (paper.addEventListener("pointerup", release),
        paper.addEventListener("pointercancel", release),
        prevBtn.addEventListener("click", function () {
          go(-1);
        }),
        nextBtn.addEventListener("click", function () {
          go(1);
        }),
        dlg.addEventListener("keydown", function (e) {
          !narrow.matches ||
            (e.key !== "ArrowRight" && e.key !== "ArrowLeft") ||
            (e.preventDefault(), go(e.key === "ArrowRight" ? 1 : -1));
        }),
        window.addEventListener("resize", function () {
          dlg.open && paginate();
        }),
        qa("[data-manifesto-open]").forEach(function (b) {
          (b.addEventListener("click", function (e) {
            (e.preventDefault(), e.stopPropagation());
            var go2 = function () {
              open(!1, b);
            };
            Promise.race([
              preload(),
              new Promise(function (r) {
                setTimeout(r, 300);
              }),
            ]).then(go2);
          }),
            ["pointerenter", "pointerdown", "touchstart", "focus"].forEach(
              function (t) {
                b.addEventListener(t, preload, { passive: !0, once: !0 });
              },
            ));
        }),
        closeBtn.addEventListener("click", close),
        dlg.addEventListener("click", function (e) {
          (e.target === dlg ||
            e.target.hasAttribute("data-book-stage") ||
            e.target === lift) &&
            close();
        }),
        dlg.addEventListener("cancel", function (e) {
          (e.preventDefault(), close());
        }),
        dlg.addEventListener("keydown", function (e) {
          e.key === "Escape" &&
            (e.preventDefault(), e.stopPropagation(), close());
        }),
        dlg.addEventListener("close", function () {
          busy ||
            (clearTimers(),
            dlg.classList.remove(
              "is-closing",
              "is-animating",
              "is-open",
              "is-flat",
            ),
            jump(lift, { transform: "", opacity: "" }),
            document.documentElement.classList.remove("is-manifesto-open"),
            L.lock && L.lock.unlock("manifesto"));
        }),
        dlg.addEventListener("keydown", function (e) {
          if (e.key === "Tab") {
            var f = [closeBtn, scroller].concat(
                narrow.matches
                  ? [prevBtn, nextBtn].filter(function (b) {
                      return !b.disabled;
                    })
                  : [],
              ),
              i = f.indexOf(document.activeElement);
            (e.preventDefault(),
              f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus({
                preventScroll: !0,
              }));
          }
        }),
        document.addEventListener("lagom:panel", function (e) {
          e.detail !== "manifesto" && dlg.open && close();
        }),
        location.hash === "#manifesto" &&
          (preload(), (opener = q("[data-manifesto-open]")), open(!0)));
    })();
  }
})();

